import React from 'react';
import NavBar from './parts/NavBar';
import AOS from 'aos';
import 'aos/dist/aos.css';
import ReactSwipe from 'react-swipe';
import api from '../api/api';
import auth from '../api/auth';
import multilanguage from '../multilanguage';
import cart from '../api/cart';
let screenHeight = 0;
let screenWidth = document.documentElement.clientWidth;

export default  class Home extends React.Component {

    constructor() {
        super();
        this.state={
            visibleNavBar: true,
        }
        this.reactSwipeEl = React.createRef();
        this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount(){
        AOS.init();     
        screenHeight = document.documentElement.clientHeight;
        window.addEventListener('resize',this.handleResize);
    }

    componentWillUnmount(){
        window.removeEventListener('resize',this.handleResize);
    }

    handleResize(){
        if(screenHeight - document.documentElement.clientHeight > 150){
            screenHeight = document.documentElement.clientHeight;
            this.setState({visibleNavBar: false})
        }
        if(screenHeight - document.documentElement.clientHeight < -150){
            screenHeight = document.documentElement.clientHeight;
            this.setState({visibleNavBar: true})
        }
    }

    visibleSearch(){
        document.getElementById('search_header').style.width = '90%';
        document.getElementById('search_header').style.opacity = '1';
    }

    closeSearch(){
        document.getElementById('search_header').style.width = '0';
        document.getElementById('search_header').style.opacity = '0';
    }



    render() {
        return (
           <div className="app_container">

               {/* HEADER */}
                <div className="home_header">
                <div className="home_header_inner">
                    <div className="home_header_search" >
                        {/* <img src={require('../assets/images/search1.svg')} /> */}
                    </div>
                    <div id="search_header" className="container_input_searchheader">
                        <input className="search_inputheader" type="text" placeholder={multilanguage.search_simple} />
                        <img onClick={() => this.closeSearch()} src={require('../assets/images/search1.svg')} />
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="150" height="41" viewBox="0 0 178 44.02"><g transform="translate(50 12)"><path d="M15.11,10.672A7.524,7.524,0,0,0,13.068,9.4a15.668,15.668,0,0,0-2.689-.848A20.99,20.99,0,0,1,6.815,7.432,1.625,1.625,0,0,1,5.671,5.97a1.586,1.586,0,0,1,.686-1.292A4.154,4.154,0,0,1,8.794,4.15a8.6,8.6,0,0,1,3.044.488,8.435,8.435,0,0,1,2.084,1.079L16.466,2.2A10.577,10.577,0,0,0,13.193.55,15.291,15.291,0,0,0,8.794,0,10.277,10.277,0,0,0,5.9.422,9.1,9.1,0,0,0,3.314,1.631,6.31,6.31,0,0,0,1.459,3.578,4.979,4.979,0,0,0,.751,6.223a4.825,4.825,0,0,0,.6,2.479A6.241,6.241,0,0,0,2.9,10.482a7.849,7.849,0,0,0,2.021,1.163A17.208,17.208,0,0,0,7,12.324a25.211,25.211,0,0,1,2.586.721,7.77,7.77,0,0,1,1.5.674,1.807,1.807,0,0,1,.708.7,1.829,1.829,0,0,1,.167.781,1.439,1.439,0,0,1-.958,1.4,6.371,6.371,0,0,1-2.543.422,7.834,7.834,0,0,1-3.189-.612,7.28,7.28,0,0,1-2.312-1.547L0,18.125a8.259,8.259,0,0,0,3.543,2.308,14.747,14.747,0,0,0,4.96.782,11.376,11.376,0,0,0,3.231-.444A8.987,8.987,0,0,0,14.4,19.523a6.047,6.047,0,0,0,1.816-1.969,5.168,5.168,0,0,0,.666-2.605,6.112,6.112,0,0,0-.459-2.477,5.208,5.208,0,0,0-1.313-1.8" transform="translate(0 0.001)" fill="#0053a0"/><path d="M11.256,13.595,5.671,0H0L8.8,19.631l-.625,1.582a11.342,11.342,0,0,1-1.356,2.609,1.976,1.976,0,0,1-1.646.839,2.3,2.3,0,0,1-1.25-.322A9.974,9.974,0,0,1,3,23.681L.794,27.194a6.187,6.187,0,0,0,1.938,1.121,8.193,8.193,0,0,0,2.771.4,5.517,5.517,0,0,0,3.167-.846,7.421,7.421,0,0,0,2.1-2.18,15.127,15.127,0,0,0,1.439-2.9c.39-1.044.777-2,1.167-2.987L21.549,0H16.172Z" transform="translate(18.047 0.8)" fill="#0053a0"/><path d="M10.8,0A7.713,7.713,0,0,0,8.721.256,7.429,7.429,0,0,0,7.074.912a6.705,6.705,0,0,0-1.252.869,10.936,10.936,0,0,0-.895.949L4.8.546H0V20.31H4.96V9.528a5.845,5.845,0,0,1,.379-2.053A5.412,5.412,0,0,1,6.334,5.8,4.425,4.425,0,0,1,9.716,4.279a3.435,3.435,0,0,1,2.6,1.038A3.988,3.988,0,0,1,13.28,8.26V20.31h4.96V8.216a8.855,8.855,0,0,0-1.883-5.992A6.9,6.9,0,0,0,10.8,0" transform="translate(42.13 0.254)" fill="#0053a0"/><path d="M10.337,21.218a10.994,10.994,0,0,1-4.253-.8,9.6,9.6,0,0,1-3.272-2.227A9.682,9.682,0,0,1,.729,14.779,12.756,12.756,0,0,1,0,10.376,11.257,11.257,0,0,1,.729,6.29,10.1,10.1,0,0,1,2.771,3.007,9.6,9.6,0,0,1,5.9.806,9.864,9.864,0,0,1,9.919,0a9.483,9.483,0,0,1,4.523,1A8.461,8.461,0,0,1,17.423,3.6a10.888,10.888,0,0,1,1.662,3.641,17.218,17.218,0,0,1,.536,4.15v.745H4.961a3.9,3.9,0,0,0,.479,1.976,5.013,5.013,0,0,0,1.251,1.512,5.6,5.6,0,0,0,1.75.975,5.928,5.928,0,0,0,1.939.336,9.993,9.993,0,0,0,2.479-.273,9.828,9.828,0,0,0,1.814-.637,5.751,5.751,0,0,0,1.229-.761c.32-.271.565-.492.729-.655L19.3,17.661l-.248.251-.015.016-.427.433a8.371,8.371,0,0,1-1.625,1.206,12.479,12.479,0,0,1-2.708,1.141A13.431,13.431,0,0,1,10.337,21.218ZM9.919,4.195A5.419,5.419,0,0,0,7.772,4.6,5.117,5.117,0,0,0,6.209,5.627a4.437,4.437,0,0,0-.958,1.392,3.466,3.466,0,0,0-.332,1.556h9.586a3.894,3.894,0,0,0-.292-1.555,4.382,4.382,0,0,0-.857-1.409A4.422,4.422,0,0,0,11.92,4.6,4.735,4.735,0,0,0,9.919,4.195Z" transform="translate(64.27 0.001)" fill="#0053a0"/><path d="M10.92,14.232,5.669,0H0L8.3,19.764h5L21.549,0H16.172Z" transform="translate(84.569 0.8)" fill="#0053a0"/><path d="M10.5,21.218a10.576,10.576,0,0,1-4.271-.849,9.945,9.945,0,0,1-3.314-2.308A10.614,10.614,0,0,1,.773,14.674a11.184,11.184,0,0,1,0-8.172A10.389,10.389,0,0,1,2.919,3.135,10.172,10.172,0,0,1,6.233.849,10.548,10.548,0,0,1,10.5,0a10.545,10.545,0,0,1,4.271.849,10.18,10.18,0,0,1,3.315,2.286A10.478,10.478,0,0,1,20.237,6.5a11.221,11.221,0,0,1,0,8.172,10.705,10.705,0,0,1-2.148,3.388,9.952,9.952,0,0,1-3.315,2.308A10.573,10.573,0,0,1,10.5,21.218Zm0-16.9a5.054,5.054,0,0,0-2.459.571A5.385,5.385,0,0,0,6.316,6.375,6.256,6.256,0,0,0,5.294,8.407a7.642,7.642,0,0,0-.334,2.181,7.54,7.54,0,0,0,.334,2.2,6.557,6.557,0,0,0,1.022,2.037,5.244,5.244,0,0,0,1.729,1.5A5.044,5.044,0,0,0,10.5,16.9a5.035,5.035,0,0,0,2.457-.573,5.261,5.261,0,0,0,1.731-1.5,6.593,6.593,0,0,0,1.022-2.037,7.628,7.628,0,0,0,.332-2.2,7.733,7.733,0,0,0-.332-2.181,6.375,6.375,0,0,0-1.022-2.032,5.4,5.4,0,0,0-1.731-1.482A5.045,5.045,0,0,0,10.5,4.321Z" transform="translate(106.993 0)" fill="#0053a0"/></g><path d="M3.166,11.972a6.327,6.327,0,0,0,2.962.857h0l11.3.012-5.6-9.834-.006.007A6.376,6.376,0,0,0,.871,3.2a6.426,6.426,0,0,0,2.3,8.769" transform="translate(0 7.825)" fill="#0053a0"/><path d="M0,6.385A6.376,6.376,0,0,0,.708,9.4v0l5.673,9.854,5.676-9.8v0A6.411,6.411,0,1,0,0,6.385" transform="translate(13.446 0)" fill="#0053a0"/><path d="M7.88.852A6.365,6.365,0,0,0,5.661,3l0,0L0,12.848l11.262.032,0-.009a6.288,6.288,0,0,0,2.956-.853,6.47,6.47,0,0,0,2.356-8.782A6.337,6.337,0,0,0,7.88.852" transform="translate(22.171 7.831)" fill="#0053a0"/><path d="M14.238.888A6.342,6.342,0,0,0,11.275.03l.009-.007L0,0,5.6,9.833h0A5.592,5.592,0,0,0,7.8,11.989,6.415,6.415,0,0,0,14.238.888" transform="translate(22.237 23.334)" fill="#0053a0"/><path d="M12.766,12.855a6.434,6.434,0,0,0-.744-3.01l.012,0L6.412,0,.756,9.8l0,0A6.53,6.53,0,0,0,0,12.8a6.383,6.383,0,1,0,12.766.058" transform="translate(13.394 24.779)" fill="#0053a0"/><path d="M9.535,12a6.376,6.376,0,0,0,2.219-2.153l0,.012L17.419.036,6.159,0l0,0A6.43,6.43,0,0,0,3.2.844,6.467,6.467,0,0,0,.845,9.623,6.335,6.335,0,0,0,9.535,12" transform="translate(0.053 23.335)" fill="#0053a0"/></svg>
                    <div className="header_cart_container"  onClick={() => this.props.history.push('/cart')}>
                        <img src={require('../assets/images/cartIcon.svg')} />
                        <div className="header_cart_container_bullet">{cart.itemCount}</div>
                    </div>
                </div>
               </div>


               {/* INTRO */}
               <div className="home_intro_container">
                   <div className="home_intro_avatar_container">
                        <img className="home_intro_avatar" src={require('../assets/images/personPlaceholder.jpg')} />
                        <div className="home_intro_edit_button" onClick={() => this.props.history.push('/edit_profile')}>
                            <img src={require('../assets/images/pencil.svg')} />
                        </div>
                   </div>
                    <div className="home_intro_right_container">
                        <div className="home_intro_title">{multilanguage.good_morning}</div>
                        <div className="home_intro_person_name">{auth.auth.user.FirstName} {auth.auth.user.LastName}</div>
                    </div>
               </div>

                {/* CREATE ORDER BOX */}
                <div className="home_order_box" onClick={() => this.props.history.push('/new_order')}>
                <div className="home_order_box_inner">
                    <div className="home_order_box_left">
                        <div className="home_order_box_title">{multilanguage.create_new_order}</div>
                        <div className="home_order_box_subtitle">{multilanguage.create_new_order_patient}</div>
                    </div>
                    <img className="home_order_box_right_image" src={require('../assets/images/plusShape.svg')} />
                </div>
                </div>
                
                <div className="flex_container_title_and_button">
                    <div className="home_section_title">{multilanguage.my_dashboard}</div>
                    {/* <div className="home_section_border_button" onClick={() => this.props.history.push('/new_patient',{edit:false})}>
                        <img className="home_order_box_right_image" src={require('../assets/images/bluePlus.svg')} />
                        <span>{multilanguage.new_patient_simple}</span>
                    </div> */}
                </div>

                 {/* BOXES */}

                 <div className="home_boxes_container">
                     <div data-aos="zoom-in-right" data-aos-duration="700" className="home_box lightblue" onClick={() => this.props.history.push('/library')}>
                        <img src={require('../assets/images/folder.svg')} />
                        <div>{multilanguage.medical_library}</div>
                     </div>
                     <div data-aos="zoom-in-left" data-aos-duration="700" className="home_box yellow" onClick={() => this.props.history.push('/latest_results')}>
                        <img src={require('../assets/images/file.svg')} />
                        <div>{multilanguage.results}</div>
                        {/* <div className="home_box_absolute_notification">11 {multilanguage.new_simple}</div> */}
                     </div>
                     <div data-aos="zoom-in-right" data-aos-duration="700" className="home_box blue" onClick={() => this.props.history.push('/patients')}>
                        <img src={require('../assets/images/patients.svg')} />
                        <div>{multilanguage.my_patients}</div>
                     </div>
                     <div data-aos="zoom-in-left" data-aos-duration="700" className="home_box gray" onClick={() => this.props.history.push('/orders')}>
                        <img src={require('../assets/images/bag.svg')} />
                        <div>{multilanguage.my_orders}</div>
                     </div>
                 </div>

                 {/* <div className="flex_container_title_and_button">
                    <div className="home_section_title">{multilanguage.news_simple}</div>
                </div>

                <ReactSwipe
                    className="homeCarousel"
                    ref={this.reactSwipeEl}
                    swipeOptions={{ continuous: true, auto: 3000}}
                >
                <div>
                    <img style={{width:screenWidth*0.9}} className="bannerHomeImage" src={require('../assets/images/banner.png')} />
                 </div>
                 <div>
                    <img style={{width:screenWidth*0.9}} className="bannerHomeImage" src={require('../assets/images/banner.png')} />
                 </div>
                 <div>
                    <img style={{width:screenWidth*0.9}} className="bannerHomeImage" src={require('../assets/images/banner.png')} />
                 </div>
                </ReactSwipe>   */}
                {this.state.visibleNavBar ?
                  <NavBar navigation={this.props.history} />
                  : null}

           </div>
)}
}
